import { Box, Button, Chip, Typography } from '@mui/material';
import { ColumnDef } from '@tanstack/react-table';
import DataTable from 'components/Common/DataTable';
import Search from 'components/Common/Search';
import { HiOutlineCog6Tooth } from 'react-icons/hi2';
import { DomainBusinessMapping } from 'apis/agency/telephony/types';

interface Props {
  rows: DomainBusinessMapping[];
  searchText: string | null;
  setSearchText: React.Dispatch<React.SetStateAction<string | null>>;
  isLoading?: boolean;
  onConfigure: (business: DomainBusinessMapping) => void;
}

export default function NetsapiensMappingTable({ rows, searchText, setSearchText, isLoading, onConfigure }: Props) {
  const columns: ColumnDef<DomainBusinessMapping>[] = [
    {
      header: 'BUSINESS NAME',
      accessorKey: 'name',
      minSize: 220
    },
    {
      header: 'NETSAPIENS DOMAIN',

      minSize: 180,
      cell: ({ row }) => {
        const domain = row.original.domain;
        return domain ? (
          <Typography fontSize={14}>{domain}</Typography>
        ) : (
          <Typography fontSize={14} color='secondary'>
            No domain mapped yet
          </Typography>
        );
      }
    },
    {
      header: 'CSP NAME',
      minSize: 140,
      cell: ({ row }) => {
        const cspName = row.original.csp_name;
        return cspName ? (
          <Typography fontSize={14}>{cspName}</Typography>
        ) : (
          <Typography fontSize={14} color='secondary'>
            No CSP mapped yet
          </Typography>
        );
      }
    },
    {
      header: 'STATUS',
      id: 'status',
      minSize: 100,
      cell: ({ row }) =>
        row.original.mapped ? (
          <Chip label='Mapped' size='small' sx={{ color: '#077f13', bgcolor: '#dbfcde', borderRadius: 3 }} />
        ) : (
          <Chip label='Unmapped' sx={{ color: '#da0808', bgcolor: '#fff2f2', borderRadius: 3 }} />
        )
    },
    {
      header: 'ACTION',
      id: 'action',

      minSize: 140,
      cell: ({ row }) => (
        <Button
          variant='outlined'
          size='small'
          startIcon={<HiOutlineCog6Tooth />}
          sx={{ width: 'fit-content', borderRadius: '24px', px: 1.5, fontWeight: 500 }}
          onClick={() => onConfigure(row.original)}
        >
          Configure
        </Button>
      )
    }
  ];

  return (
    <>
      <Box pb={2}>
        <Search
          placeholder='Search Business'
          size='small'
          searchText={searchText}
          setSearchText={setSearchText}
          fullWidth
        />
      </Box>
      <DataTable data={rows} columns={columns} isLoading={isLoading} />
    </>
  );
}
